module.exports = __webpack_public_path__ + "static/img/ent-detail-94.e48943b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-94.jpg
// module id = LCvG
// module chunks = 52